import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem("auth_token"));
  const [email, setEmail] = useState(() => localStorage.getItem("auth_email"));
  const [loading, setLoading] = useState(false);

  const login = async (emailVal, password) => {
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email: emailVal, password });
      localStorage.setItem("auth_token", r.data.access_token);
      localStorage.setItem("auth_email", r.data.email);
      setToken(r.data.access_token);
      setEmail(r.data.email);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: e.response?.data?.detail || "Login failed" };
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("auth_email");
    setToken(null);
    setEmail(null);
  };

  return (
    <AuthCtx.Provider value={{ token, email, loading, login, logout, isAuthed: !!token }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
